import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, LogIn } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (!res.ok) setErr(res.error || "Login failed");
    else nav("/admin");
  };

  return (
    <div data-testid="admin-login-page" className="min-h-[70vh] grid place-items-center px-6 py-16">
      <div className="w-full max-w-md card p-8">
        <div className="w-14 h-14 rounded-2xl bg-[#21C078]/10 grid place-items-center text-[#21C078]">
          <Lock className="w-7 h-7" />
        </div>
        <h1 className="mt-5 text-3xl font-black tracking-tight">Admin login</h1>
        <p className="mt-1 text-[#1C1C1C]/60">Manage team photos, gallery projects and messages.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <label className="block text-sm font-bold text-[#1C1C1C]/70 mb-2">Email</label>
            <Input required type="email" data-testid="admin-login-email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-2xl border-[#21C078]/20 focus-visible:ring-[#21C078]" />
          </div>
          <div>
            <label className="block text-sm font-bold text-[#1C1C1C]/70 mb-2">Password</label>
            <Input required type="password" data-testid="admin-login-password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-2xl border-[#21C078]/20 focus-visible:ring-[#21C078]" />
          </div>
          {err && <div data-testid="admin-login-error" className="text-sm font-bold text-[#C12135]">{err}</div>}
          <Button type="submit" data-testid="admin-login-submit" disabled={loading} className="btn-pill-primary w-full disabled:opacity-70">
            {loading ? "Signing in…" : (<>Sign in <LogIn className="w-4 h-4" /></>)}
          </Button>
        </form>
      </div>
    </div>
  );
}
